import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: "2rem",
    paddingLeft: 32,
    paddingRight: 32,
    position: "relative",
    zIndex: 1
  },
  buttonAccent: {
    color: "white",
    borderColor: "white"
  },
  inverted: {
    color: theme.palette.primary.main,
    background: "white",
    "&:hover,&:focus,&:active": {
      background: "#e3e3e3"
    }
  }
}));

export default function StyledButton({ children, inverted, ...props }) {
  const classes = useStyles();
  const classNames =
    props.variant == "outlined"
      ? clsx(props.className, classes.button, { [classes.inverted]: inverted })
      : clsx(props.className, classes.button, classes.buttonAccent);
  return (
    <Button
      variant="outlined"
      {...props}
      disableElevation
      className={classNames}
    >
      {children}
    </Button>
  );
}
